import React, { createContext, useContext, useState, useEffect } from 'react';
import * as api from '../services/api';

const SiteConfigContext = createContext({});

export const SiteConfigProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [navigation, setNavigation] = useState([]);
  const [footer, setFooter] = useState({});
  const [seo, setSeo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const [catRes, navRes, footerRes, seoRes] = await Promise.all([
          api.getSiteConfig('categories'),
          api.getSiteConfig('navigation'),
          api.getSiteConfig('footer'),
          api.getSiteConfig('seo'),
        ]);
        
        setCategories(catRes.data || []);
        setNavigation(navRes.data || []);
        setFooter(footerRes.data || {});
        setSeo(seoRes.data || {});
      } catch (error) {
        console.error('Error loading site config:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchConfig();
  }, []);

  const refreshConfig = async (configType) => {
    try {
      const res = await api.getSiteConfig(configType);
      switch (configType) {
        case 'categories':
          setCategories(res.data || []);
          break;
        case 'navigation':
          setNavigation(res.data || []);
          break;
        case 'footer':
          setFooter(res.data || {});
          break;
        case 'seo':
          setSeo(res.data || {});
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(`Error refreshing ${configType}:`, error);
    }
  };

  const getActiveCategories = () => categories.filter(c => c.is_active !== false);
  const getActiveNavigation = () => navigation.filter(n => n.is_active !== false).sort((a, b) => a.order - b.order);

  return (
    <SiteConfigContext.Provider value={{
      categories,
      navigation,
      footer,
      seo,
      loading,
      refreshConfig,
      getActiveCategories,
      getActiveNavigation,
    }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => {
  const context = useContext(SiteConfigContext);
  if (!context) {
    throw new Error('useSiteConfig must be used within a SiteConfigProvider');
  }
  return context;
};

export default SiteConfigContext;
